<template>
  <div class="wrapper">
    <loading
      name="lp"
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
    <notifications></notifications>
    <parallax
      class="page-header header-filter header-small"
      parallax-active="true"
      :style="headerStyle"
    >
      <div class="container">
        <div class="md-layout">
          <div
            class="md-layout-item md-size-66 md-small-size-100 mx-auto text-center"
          ></div>
        </div>
      </div>
    </parallax>
    <div class="main main-raised">
      <div class="section pb-0 pt-0">
        <div class="container">
          <md-card class="md-card-plain">
            <md-card-content>
              <h3 class="card-title">{{ labels.shopcart }}</h3>
              <div class="text-center: center" v-if="order.total === 0">
                <h2>{{ labels.cartempty }}</h2>
              </div>
              <div
                class="md-layout vertical-center padding-bottom-20"
                :key="item.id + item.priceid"
                v-for="item in order.details"
              >
                <div class="md-layout-item md-size-100">
                  <table width="100%">
                    <tr>
                      <td>
                        <h4 class="title">{{ item.title }}</h4>
                        <span style="font-size: 14px"
                          >{{ item.spec }} <small>₼</small>
                          {{ item.price }}</span
                        >
                      </td>
                      <td width="100px">
                        <div class="md-group">
                          <md-button
                            v-if="
                              $store.getters.itemCountInOrder(item.priceid) > 0
                            "
                            :class="'md-just-icon md-simple md-danger'"
                            @click="onRemoveFromBasket(item)"
                          >
                            <i :class="'fas fa-minus-square'" />
                          </md-button>
                          <span
                            style="font-size: 12px; font-weight: bold; padding-top:15px"
                            v-if="
                              $store.getters.itemCountInOrder(item.priceid) > 0
                            "
                            >{{
                              $store.getters.itemCountInOrder(item.priceid)
                            }}</span
                          >
                          <md-button
                            v-if="
                              $store.getters.itemCountInOrder(item.priceid) <=
                                30
                            "
                            :class="'md-just-icon md-simple md-success'"
                            @click="onAddToBasket(item)"
                          >
                            <i :class="'fas fa-plus-square'" />
                          </md-button>
                        </div>
                      </td>
                      <td width="60px" style="text-align: right">
                        <h4>
                          <small>₼</small>
                          {{ item.amount }}
                        </h4>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
              <div class="table table-stats">
                <div class="td-price" v-if="order.total > 0">
                  <div class="td-total">{{ labels.total }}</div>
                  <span>
                    <small>₼</small>
                    {{ $store.state.order.total }}
                  </span>
                </div>
              </div>
              <div
                class="md-layout md-alignment-top-center"
                v-if="order.total > 0"
              >
                <div class="md-layout-item md-size-50 md-small-size-100">
                  <div class="md-layout md-alignment-top-center">
                    <div class="md-layout-item md-size-50">
                      <md-field width="200px">
                        <label>{{ labels.tablenumber }}</label>
                        <md-input
                          width="150px"
                          key="inout11"
                          v-model="draft.tablenumber"
                          min="1"
                          max="99"
                          type="number"
                        ></md-input>
                      </md-field>
                    </div>
                    <div
                      class="md-layout-item md-size-50"
                      style="padding-top: 10px"
                    >
                      <el-select v-model="draft.pax" :placeholder="labels.pax">
                        <el-option
                          v-for="p in persons"
                          :key="p"
                          :label="p"
                          :value="p"
                        >
                        </el-option>
                      </el-select>
                    </div>
                    <div class="md-layout-item md-size-100 text-center">
                      <md-button
                        @click="$router.push({ path: '/m2/' + id })"
                        class="md-round md-default"
                        ><md-icon>keyboard_arrow_left</md-icon
                        >{{ labels.menu }}</md-button
                      >
                      <md-button class="md-success md-round" @click="onSave()">
                        {{ labels.finish }}
                      </md-button>
                    </div>
                  </div>
                </div>
              </div>
            </md-card-content>
          </md-card>
        </div>
      </div>
    </div>

    <el-dialog
      :visible.sync="showMessage"
      width="100%"
      :center="true"
      :before-close="onClose"
    >
      <div style="text-align: center">
        <h2>{{ labels.ordersent }}</h2>
        <h3 class="title">{{ labels.ordernumber }}: {{ ordernumber }}</h3>
        <md-button class="md-success md-round" @click="onClose">{{
          labels.close
        }}</md-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Mixins from "@/plugins/basicMixins";
import { fileUrl, nophoto, Round2 } from "../services/helper";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { CreateOrder } from "../services/share";
import { Select, Option, Dialog } from "element-ui";
export default {
  props: { id: String },
  components: {
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    [Dialog.name]: Dialog
  },
  mixins: [Mixins.HeaderImage],
  computed: {
    ...mapState({
      order: state => state.order,
      bkg: state => state.menubkg,
      info: state => state.info
    }),
    fileurl() {
      return fileUrl;
    },
    image() {
      return this.bkg ? this.fileurl + this.bkg : "";
    }
  },
  data() {
    return {
      persons: [],
      nophoto: nophoto,
      isLoading: false,
      ordernumber: "",
      showMessage: false,
      draft: {
        id: "",
        shareid: this.id,
        company: "",
        customername: "",
        companyemail: "",
        phone: "",
        email: "",
        tablenumber: 1,
        pax: 3,
        addressnotes: "",
        street: "",
        entrance: "",
        entrancecode: "",
        flat: "",
        floor: 1,
        house: "",
        latlng: "",
        changefrom: 0,
        paytype: 1,
        deliverytype: 3,
        deliverytimetype: 1,
        deliverysum: 0,
        deliverytime: "",
        locationid: "",
        location: "",
        lat: "",
        lng: "",
        details: []
      },
      labels: {
        name: this.localeLabel("name"),
        price: this.localeLabel("price"),
        total: this.localeLabel("total"),
        count: this.localeLabel("count"),
        amount: this.localeLabel("amount"),
        continueshop: this.localeLabel("continueshop"),
        gotobasket: this.localeLabel("gotobasket"),
        shopcart: this.localeLabel("shopcart"),
        finish: this.localeLabel("finish"),
        cartempty: this.localeLabel("cartempty"),
        tablenumber: this.localeLabel("tablenumber"),
        pax: this.localeLabel("pax"),
        menu: this.localeLabel("menu"),
        reqtablepax: this.localeLabel("reqtablepax"),
        ordersent: this.localeLabel("ordersent"),
        ordernumber: this.localeLabel("ordernumber"),
        close: this.localeLabel("close")
      }
    };
  },
  methods: {
    onAddToBasket(item) {
      let newItem = {};
      newItem.count = 1;
      newItem.id = item.id;
      newItem.priceid = item.priceid;
      newItem.price = Round2(item.price);
      newItem.amount = Round2(item.price);

      this.$store.dispatch("addToOrder", Object.assign({}, newItem));
    },

    itemCountInBasket(id) {
      return this.$store.getters.itemCountInOrder(id);
    },
    onRemoveFromBasket(item) {
      item.count = this.itemCountInBasket(item.priceid) - 1;
      if (item.count == 0) {
        this.remove(item);
        if (this.order.total === 0) {
          this.$router.push({ path: "/m2/" + this.id });
        }
        return;
      }
      if (item.count < 0) return;
      item.amount = Round2(item.count * item.price);
      this.$store.dispatch("updateItemCount", item);
    },
    remove(item) {
      this.$store.dispatch("removeItem", item);
    },

    onSave() {
      if (!(this.draft.tablenumber > 0) || !this.draft.pax)
        alert(this.labels.reqtablepax);
      else {
        this.isLoading = true;
        this.draft.details = this.order.details;
        CreateOrder(this.draft).then(response => {
          this.isLoading = false;
          if (response.data.result) {
            this.ordernumber = response.data.result.ordernumber.padStart(
              4,
              "0"
            );
            this.showMessage = true;
            this.$store.dispatch("clearCart", this.id);
          }
        });
      }
    },
    onClose() {
      this.showMessage = false;
      this.$router.push({ path: "/m2/" + this.id });
    }
  },
  mounted() {
    this.draft.company = this.info.company;
    this.draft.companyemail = this.info.email;
  },
  created() {
    if (this.order.total === 0) {
      this.$router.push({ path: "/m2/" + this.id });
    }
    this.$store.dispatch("fetchMenuBkg", this.id);
    for (let i = 1; i <= 20; i++) {
      this.persons.push(i);
    }
  }
};
</script>

<style lang="scss">
.table-stats {
  display: flex;
  align-items: center;
  text-align: right;
  flex-flow: row wrap;

  .td-price .td-total {
    display: inline-flex;
    font-weight: 500;
    font-size: 1.0625rem;
    margin-right: 50px;
  }

  .td-price {
    font-size: 26px;
    border-top: 1px solid #ddd;
  }

  .td-price,
  > div {
    flex: 0 0 100%;
    padding: 12px 8px;
  }
}
.text-center {
  text-align: center;
}
.vertical-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.padding-bottom-20 {
  padding-bottom: 20px;
}
@media only screen and (max-width: 600px) {
  .grid-title {
    display: none;
  }
  .shop-card-title {
    font-weight: bold;
    display: block;
  }
}
@media screen and (min-width: 601px) {
  .grid-title {
    display: block;
  }
  .shop-card-title {
    display: none;
  }
}
</style>
